//@ts-nocheck

var simpleArrayMatch = function simpleArrayMatch(array1, array2) {
  return array1.length === array2.length && array1.every(function (val, index) {
    return val === array2[index];
  });
};
export { simpleArrayMatch };